/**
 * Project Manager Service
 * API integration for project manager directory and profiles
 */

import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Create axios instance with default config
const apiClient = axios.create({
    baseURL: API_BASE_URL,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Handle response errors
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

const projectManagerService = {
    
    /**
     * Get all project managers with filtering and pagination (Public directory)
     */
    getAllProjectManagers: async (filters = {}, pagination = {}) => {
        try {
            const params = {
                ...filters,
                ...pagination
            };
            
            const response = await apiClient.get('/project-managers', { params });
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to fetch project managers');
        }
    },
    
    /**
     * Get project manager profile by ID (Public view)
     */
    getProjectManagerById: async (projectManagerId) => {
        try {
            const response = await apiClient.get(`/project-managers/${projectManagerId}`);
            return response.data.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to fetch project manager profile');
        }
    }
};

export default projectManagerService;

